import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { CoverImageFragmentDoc } from '../../../fragments.generated';
export type AssignedByContentMembershipModuleFragment = { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, archivedAt?: string | null, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null }, draftVersion: { __typename?: 'ModuleVersion', id: string } };

export type AssignedByModuleContentMembershipFragment = { __typename?: 'ModuleContentMembership', id: number, uuid: string, moduleVersion?: { __typename?: 'ModuleVersion', id: string, module: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, archivedAt?: string | null, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null }, draftVersion: { __typename?: 'ModuleVersion', id: string } } } | null };

export type AssignedByCourseFragment = { __typename?: 'Course', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, archivedAt?: string | null, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } };

export const AssignedByContentMembershipModuleFragmentDoc = gql`
    fragment AssignedByContentMembershipModule on Module {
  id
  libraryItem {
    id
    name {
      en
    }
    coverImage {
      ...CoverImage
    }
    archivedAt
  }
  draftVersion {
    id
  }
}
    ${CoverImageFragmentDoc}`;
export const AssignedByModuleContentMembershipFragmentDoc = gql`
    fragment AssignedByModuleContentMembership on ModuleContentMembership {
  id
  uuid
  moduleVersion {
    id
    module {
      ...AssignedByContentMembershipModule
    }
  }
}
    ${AssignedByContentMembershipModuleFragmentDoc}`;
export const AssignedByCourseFragmentDoc = gql`
    fragment AssignedByCourse on Course {
  id
  libraryItem {
    id
    archivedAt
    name {
      en
    }
    coverImage {
      ...CoverImage
    }
  }
}
    ${CoverImageFragmentDoc}`;